import type { DirectusNetworkBranding } from '@/types/directus-types'
import { fakeNoData } from './bad-placeholder-helpers'

/**
 * Fetches network branding for all networks that have charging stations in DB.
 *
 * @returns A list of network branding records if successful, undefined if not.
 */
export async function fetchNetworkBranding(): Promise<DirectusNetworkBranding[] | undefined> {
  // fetch all directus records from the NetworkBranding collection
  const res = await fakeNoData()
  return res
}
